"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Level = _ref => {
  let {
    isMobile,
    className,
    renderAs,
    children,
    levelLeft,
    levelRight
  } = _ref;
  const display = isMobile ? 'mobile' : null;
  const classNames = (0, _classnames.default)({
    [`is-${display}`]: display
  });
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('level', className, classNames)
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, levelLeft && /*#__PURE__*/_react.default.createElement("div", {
    className: "level-left"
  }, levelLeft), children, levelRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "level-right"
  }, levelRight)));
};
Level.propTypes = {
  isMobile: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  levelLeft: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  levelRight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Level.defaultProps = {
  renderAs: 'nav'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Level);
//# sourceMappingURL=Level.js.map